import UnbindedSubcategories from "../symbols/unbindedSubcategories";
import { HttpRequestGet } from "../../service";
const unbindedSubcategoriesAction = () => ({
  type: UnbindedSubcategories.UNBINDED_SUBCATEGORIES,
});
const unbindedSubcategoriesSuccessAction = (data: any) => ({
  type: UnbindedSubcategories.UNBINDED_SUBCATEGORIES_SUCCESS,
  payload: data,
});
const unbindedSubcategoriesFailureAction = (data: any) => ({
  type: UnbindedSubcategories.UNBINDED_SUBCATEGORIES_FAILURE,
  payload: data,
});
const clearUnbindedSubcategoriesAction = () => ({
  type: UnbindedSubcategories.CLEAR_UNBINDED_SUBCATEGORIES,
});

export function getUnbindedSubcategories() {
  return (dispatch: any) => {
    dispatch(unbindedSubcategoriesAction());
    HttpRequestGet(
      `/upc/subcategory/unbinded`,
      dispatch,
      unbindedSubcategoriesSuccessAction,
      unbindedSubcategoriesFailureAction,
      true
    );
  };
}

export function clearUnbindedSubcategories() {
  return (dispatch: any) => {
    dispatch(clearUnbindedSubcategoriesAction());
  };
}
